import { IntegrationConfig } from 'modules/Integrations/domain'
import logo from './snowflakeLogo.svg'
import { NoConfiguration } from 'modules/Integrations/integrationsConfig/common/NoConfiguration'
import { SnowflakeIntegrationDetail } from './SnowflakeIntegrationDetail'

export const snowflakeIntegrationConfig: IntegrationConfig = {
  logoUrl: logo,
  smallLogoUrl: logo,
  statusLabel: null,
  documentationUrl: 'https://docs.sequencehq.com/connectors/data-overview',
  title: 'Snowflake',
  features: {
    canDeleteLinks: false,
    canUninstall: false,
    isDocumentationOnly: true
  },
  description: 'Sync Sequence data to your data stack.',
  components: {
    detail: SnowflakeIntegrationDetail,
    management: NoConfiguration
  }
}
